import { isEmpty } from 'validator';

export function required(fieldName) {
  let result = true;

  return (value = '') => {
    if (typeof value === 'string') {
      result = !isEmpty(value);
    } else if (value instanceof Array) {
      result = value.length > 0;
    } else {
      result = !!value;
    }

    return result ? undefined : `${fieldName} cannot be blank`;
  };
}
